<template>
  <v-card class="card-info-container mb-4" outlined>
    <v-card-text class="pa-4">
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon class="mr-3" color="primary" size="24">
            mdi-credit-card
          </v-icon>
          <div>
            <div class="text-subtitle-2 font-weight-medium primary--text">
              {{ $t('modules.portalalumno.payments.cardRegistration.view.cardInfoTitle') }}
            </div>
            <div class="text-caption text--secondary mt-1">
              {{ $t('modules.portalalumno.payments.cardRegistration.view.cardInfoBrand') }}: 
              <span class="font-weight-medium">{{ cardData.brand }}</span>
            </div>
            <div class="text-caption text--secondary">
              {{ $t('modules.portalalumno.payments.cardRegistration.view.cardInfoLastFour') }}: 
              <span class="font-weight-medium">**** {{ cardData.last_four_digits }}</span>
            </div>
          </div>
        </div>
        <v-chip
          small
          color="success"
          text-color="white"
          class="font-weight-medium"
        >
          {{ $t('modules.portalalumno.payments.cardRegistration.view.active') }}
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CardInfo',
  props: {
    cardData: {
      type: Object,
      required: true,
      validator(value) {
        return value.brand && value.last_four_digits;
      }
    }
  }
}
</script>

<style scoped>
.card-info-container {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
}

.card-info-container:hover {
  border-color: #1976d2;
  background-color: #f5f5f5;
}
</style> 